<template>
  <div id="pickup">
    <div class="pickup-list">
      <h2>
        PICKUP
        <span>ピックアップ</span>
      </h2>
      <Spring />
      <JikibaV />
    </div>
  </div>
</template>

<script>
import Spring from "@/components/Parts24Springcampaign.vue";
import JikibaV from "@/components/Parts24JikibaV.vue";
export default {
  data() {
    return {};
  },
  components: {
    Spring,
    JikibaV,
  },
};
</script>

<style lang="scss" scoped>
#pickup {
  width: 100%;
  height: 100%;
  .pickup-grid {
    display: flex;
    background-color: white;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    margin-top: 2rem;
    @include tb {
      flex-direction: column-reverse;
    }
    .pickup-tx-wrap {
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      padding: 4rem;
      position: relative;
      z-index: 1;
      @include tb {
        width: 100%;
        padding: 2rem;
      }
      &::after {
        content: attr(data-text);
        position: absolute;
        left: 1rem;
        bottom: 0.5rem;
        font-size: 3rem;
        opacity: 0.15;
        color: #ff3a6b;
        z-index: -1;
        white-space: pre;
        @include tb {
          writing-mode: vertical-lr;
          right: 0.5rem;
          left: auto;
          font-size: 1rem;
        }
      }
    }
    .pickup-tx {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 1rem;

      h3 {
        font-size: 2.5rem;
        font-weight: bold;
        @include tb {
          font-size: 2rem;
        }
        @include sp {
          font-size: 1.5rem;
        }
      }

      h4 {
        font-size: 1rem;
        color: #ff3a6b;
        padding-bottom: 1rem;
        position: relative;

        font-weight: bold;
        &::after {
          content: "";
          display: block;
          width: 2rem;
          height: 1px;
          background-color: #ff3a6b;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      p {
        font-weight: normal;
        line-height: 2;
      }
      a {
        font-weight: bold;
        font-size: 1rem;
        padding: 0.5rem 1rem;
        color: #ff3a6b;
        background-color: white;
        border: 2px solid #ff3a6b;
        border-radius: 2rem;
        align-self: start;
        margin-right: 0.5rem;
        display: inline-block;
        @include sp {
          font-size: 0.8rem;
        }
      }
    }
    .pickup-img {
      overflow: hidden;
      border-radius: 1rem 0 0 1rem;
      width: 50%;
      @include tb {
        width: 100%;

        border-radius: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  h2 {
    font-weight: bold;
    font-size: 3rem;
    margin-bottom: 1em;

    padding: 0 $h-gap;
    span {
      margin-left: 1em;
      font-size: 1rem;
    }
  }
  p {
    font-size: 1rem;
  }
}
.pickup-list {
  @include tb {
    grid-template-columns: repeat(3, 1fr);
  }
  @include sp {
    grid-template-columns: repeat(2, 1fr);
  }
  .swiper {
    overflow: visible;
  }
}
</style>
